import './globals'

import './app/app.module'
import './styles/global.scss'



// WEBPACK FOOTER //
// ./index.js